const stats = [
  { value: '24/7', label: 'Chat availability mindset' },
  { value: '10k+', label: 'Family stories preserved' },
  { value: 'Win + Mac', label: 'Platform coverage' },
  { value: 'Cloud', label: 'TreeVault-ready guidance' },
];

export default function StatsBar() {
  return (
    <section className="t7-stats">
      <div className="container">
        <div className="t7-stats__grid">
          {stats.map((stat) => (
            <div key={stat.label} className="t7-stats__item">
              <p className="t7-stats__value">{stat.value}</p>
              <p className="t7-stats__label">{stat.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
